function average(list) {
  return list.reduce((a, b) => a + b) / list.length
}

function numberToPercentage(n) {
  return {
    0: 100,
    1: 100,
    2: 0,
    3: 0,
    4: 0,
  }[n]
}

function pageSupport(page, ntp = numberToPercentage) {
  return Math.round(average(page.map(ntp)))
}

function calculateSupport(votes_, ntp = numberToPercentage) {
  const votes = votes_.map(p => p.map(ntp))
  if (votes[6]) votes[6] = [average(votes[6])]

  return Math.round(average([].concat(...votes)))
}

module.exports.calculateSupport = calculateSupport
module.exports.pageSupport = pageSupport



// WEBPACK FOOTER //
// ./calculateSupport.js